import styled from "styled-components";

const Input = styled.input`
    width: 100%;
    height: 38px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin: 0;
    padding: 0 10px;
    box-sizing: border-box;
`

const InputUtil = ({ value, onChange, placeholder, type }) => {

    return(
        <Input
            value={ value }
            onChange={ onChange }
            placeholder={ placeholder }
            type={ type ? type : 'text' }
        />
    )

}

export default InputUtil;